import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './App.routes.js';
import './App.css';

const App = () => (
  <div className="main-container">
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  </div>
);

export default App;
